import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useAuth } from "@/contexts/AuthContext";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success("Account created!");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-white">
      <div className="hidden md:flex flex-1 bg-gradient-to-br from-[#7C3AED] via-[#6D28D9] to-[#4C1D95] p-12 flex-col justify-between">
        <Logo size={32} textColor="text-white" iconColor="#FFFFFF" />
        <div className="text-white max-w-md">
          <h2 className="text-4xl font-bold mb-4 leading-tight">Build your brand on autopilot.</h2>
          <p className="text-purple-100 text-lg">Join thousands of marketers using AI to create videos, campaigns, and ads in minutes.</p>
        </div>
        <p className="text-purple-200 text-sm">© 2026 Optimus Prime</p>
      </div>
      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="signup-form">
          <div className="md:hidden mb-8"><Logo size={28} /></div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Create your account</h1>
          <p className="text-gray-500 mb-8">Start free. No credit card.</p>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Full name</label>
          <input required value={name} onChange={(e) => setName(e.target.value)} className="op-input mb-4" placeholder="Jane Smith" data-testid="signup-name-input" />
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="op-input mb-4" placeholder="you@brand.com" data-testid="signup-email-input" />
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="op-input mb-6" placeholder="At least 6 characters" data-testid="signup-password-input" />
          <button type="submit" disabled={loading} className="op-btn-primary w-full justify-center" data-testid="signup-submit-btn">
            {loading ? "Creating..." : "Create account →"}
          </button>
          <p className="mt-6 text-sm text-gray-600 text-center">
            Already a user? <Link to="/login" className="text-[#7C3AED] font-semibold" data-testid="signup-login-link">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
};
export default Signup;
